import { render, staticRenderFns } from "./ThankYouForms.vue?vue&type=template&id=0f4116ea&"
import script from "./ThankYouForms.vue?vue&type=script&lang=js&"
export * from "./ThankYouForms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports